import {
	Briefcase,
	CalendarDays,
	CheckCircle2,
	GraduationCap,
	HeartPulse,
	Home,
	Laptop,
	Scale,
	ShoppingBag,
	Sparkles,
	Store,
	UtensilsCrossed,
} from 'lucide-react';

export const categoryMeta = {
	SHOPPING_RETAIL: {
		label: 'Shopping & Retail',
		short: 'Retail',
		icon: ShoppingBag,
		color: '#E8722A',
		bg: '#FFF7ED',
		description: 'Stores, makers, apparel, gifts, and specialty goods.',
	},
	FOOD_BEVERAGES: {
		label: 'Food & Beverages',
		short: 'Food',
		icon: UtensilsCrossed,
		color: '#D97706',
		bg: '#FFFBEB',
		description: 'Caterers, home kitchens, sweets, snacks, and cafes.',
	},
	BEAUTY_HEALTH: {
		label: 'Beauty & Health',
		short: 'Health',
		icon: HeartPulse,
		color: '#DB2777',
		bg: '#FDF2F8',
		description: 'Clinics, wellness, salons, and care professionals.',
	},
	PROFESSIONAL_SERVICES: {
		label: 'Professional Services',
		short: 'Services',
		icon: Briefcase,
		color: '#4F46E5',
		bg: '#EEF2FF',
		description: 'CA, legal, consulting, design, and advisory work.',
	},
	EDUCATION_TRAINING: {
		label: 'Education & Training',
		short: 'Education',
		icon: GraduationCap,
		color: '#0891B2',
		bg: '#ECFEFF',
		description: 'Classes, coaching, music, workshops, and mentoring.',
	},
	EVENTS_LEISURE: {
		label: 'Events & Leisure',
		short: 'Events',
		icon: CalendarDays,
		color: '#7C3AED',
		bg: '#F5F3FF',
		description: 'Event teams, travel, leisure, and experiences.',
	},
	TECHNOLOGY_IT: {
		label: 'Technology & IT',
		short: 'Tech',
		icon: Laptop,
		color: '#0284C7',
		bg: '#F0F9FF',
		description: 'Software, repairs, digital, automation, and IT help.',
	},
	CONSTRUCTION_HOME: {
		label: 'Construction & Home',
		short: 'Home',
		icon: Home,
		color: '#65A30D',
		bg: '#F7FEE7',
		description: 'Interiors, contractors, home services, and repairs.',
	},
	OTHER: {
		label: 'Other',
		short: 'Other',
		icon: Store,
		color: '#6B7280',
		bg: '#F9FAFB',
		description: 'Useful member services across other categories.',
	},
};

export const staticStats = [
	{label: 'Member-led listings', value: '120+', detail: 'Products, services, and hybrid businesses'},
	{label: 'Joglekar families', value: '3.4K+', detail: 'Community reach across generations'},
	{label: 'Discovery categories', value: '9', detail: 'Organized around common member needs'},
];

export const mockListings = [
	{
		_id: 'yp-static-001',
		entityType: 'service',
		entityName: 'Atharva Legal & Tax Advisory',
		tagline: 'GST, income tax, documentation, and family-business compliance handled with clarity.',
		description: 'A trusted advisory practice for small businesses, professionals, and families.',
		categories: ['PROFESSIONAL_SERVICES'],
		isPhysical: true,
		location: 'Dadar, Mumbai',
		serviceArea: '',
		photos: {logo: {url: ''}},
		verification: {isVerified: true},
		rating: {average: 4.9, count: 38},
		primaryCta: 'call',
		priceRange: 'mid-range',
		entityContactDetails: {
			whatsApp: {dialingCode: '+91', number: '9876543201'},
			calling: {dialingCode: '+91', number: '9876543201'},
			sameNumberForCalling: true,
			websiteLink: 'atharvaadvisory.in',
		},
		listedBy: {displayName: 'Nikhil Joglekar', nativePlace: 'Guhagar', imageUrl: 'NJ', imageUrlBg: '#FDF0ED'},
		credentials: {experience: '14+ Years', primaryMetric: '450+ filings'},
		highlights: [{text: 'GST support'}, {text: 'Business setup'}, {text: 'Family documentation'}],
		isFeatured: true,
		createdAt: '2026-04-28T08:00:00.000Z',
	},
	{
		_id: 'yp-static-002',
		entityType: 'hybrid',
		entityName: 'Kokum & Kanda Catering',
		tagline: 'Traditional Maharashtrian menus for pooja, thread ceremony, birthdays, and weddings.',
		description: 'Home-style festive food with seasonal menus and community references.',
		categories: ['FOOD_BEVERAGES', 'EVENTS_LEISURE'],
		isPhysical: false,
		location: '',
		serviceArea: 'Mumbai & Pune',
		photos: {logo: {url: ''}},
		verification: {isVerified: true},
		rating: {average: 4.8, count: 64},
		primaryCta: 'whatsapp',
		priceRange: 'premium',
		entityContactDetails: {
			whatsApp: {dialingCode: '+91', number: '9876543202'},
			calling: {dialingCode: '+91', number: '9876543202'},
			sameNumberForCalling: true,
			websiteLink: '',
		},
		listedBy: {displayName: 'Shruti Joglekar', nativePlace: 'Chiplun', imageUrl: 'SJ', imageUrlBg: '#FEF3C7'},
		credentials: {experience: '9+ Years', primaryMetric: '300+ events'},
		highlights: [{text: 'Pooja menus'}, {text: 'Bulk orders'}, {text: 'Seasonal specials'}],
		isFeatured: true,
		createdAt: '2026-05-02T08:00:00.000Z',
	},
	{
		_id: 'yp-static-003',
		entityType: 'product',
		entityName: 'Vedika Handloom Studio',
		tagline: 'Handpicked sarees, festive blouse pieces, and curated gifts from trusted weavers.',
		description: 'Premium retail curation for family functions and gifting.',
		categories: ['SHOPPING_RETAIL'],
		isPhysical: true,
		location: 'Karve Nagar, Pune',
		serviceArea: '',
		photos: {logo: {url: ''}},
		verification: {isVerified: true},
		rating: {average: 4.7, count: 27},
		primaryCta: 'website',
		priceRange: 'premium',
		entityContactDetails: {
			whatsApp: {dialingCode: '+91', number: '9876543203'},
			calling: {dialingCode: '+91', number: '9876543204'},
			sameNumberForCalling: false,
			websiteLink: 'vedikahandloom.in',
		},
		listedBy: {displayName: 'Madhura Joglekar', nativePlace: 'Ratnagiri', imageUrl: 'MJ', imageUrlBg: '#FCE7F3'},
		credentials: {experience: '6+ Years', primaryMetric: '80+ artisan partners'},
		highlights: [{text: 'Festive edits'}, {text: 'Gift packing'}, {text: 'Video shopping'}],
		isFeatured: true,
		createdAt: '2026-04-14T08:00:00.000Z',
	},
	{
		_id: 'yp-static-004',
		entityType: 'service',
		entityName: 'Swarangan Music Classes',
		tagline: 'Hindustani vocal, harmonium, and light music training for children and adults.',
		description: 'Structured music learning with online and in-person batches.',
		categories: ['EDUCATION_TRAINING', 'EVENTS_LEISURE'],
		isPhysical: false,
		location: '',
		serviceArea: 'Online + Thane',
		photos: {logo: {url: ''}},
		verification: {isVerified: false},
		rating: {average: 4.6, count: 19},
		primaryCta: 'whatsapp',
		priceRange: 'budget-friendly',
		entityContactDetails: {
			whatsApp: {dialingCode: '+91', number: '9876543205'},
			calling: {dialingCode: '+91', number: '9876543205'},
			sameNumberForCalling: true,
			websiteLink: '',
		},
		listedBy: {displayName: 'Radhika Joglekar', nativePlace: 'Devrukh', imageUrl: 'RJ', imageUrlBg: '#E0F2FE'},
		credentials: {experience: '11+ Years', primaryMetric: '160+ students'},
		highlights: [{text: 'Kids batches'}, {text: 'Online classes'}, {text: 'Performance prep'}],
		isFeatured: false,
		createdAt: '2026-05-04T08:00:00.000Z',
	},
	{
		_id: 'yp-static-005',
		entityType: 'service',
		entityName: 'BlueModak Web Studio',
		tagline: 'Websites, booking flows, and digital tools for small businesses and professionals.',
		description: 'Practical tech support for member businesses going digital.',
		categories: ['TECHNOLOGY_IT', 'PROFESSIONAL_SERVICES'],
		isPhysical: false,
		location: '',
		serviceArea: 'Pan India',
		photos: {logo: {url: ''}},
		verification: {isVerified: true},
		rating: {average: 4.9, count: 22},
		primaryCta: 'website',
		priceRange: 'mid-range',
		entityContactDetails: {
			whatsApp: {dialingCode: '+91', number: '9876543206'},
			calling: {dialingCode: '+91', number: '9876543206'},
			sameNumberForCalling: true,
			websiteLink: 'bluemodak.studio',
		},
		listedBy: {displayName: 'Omkar Joglekar', nativePlace: 'Pawas', imageUrl: 'OJ', imageUrlBg: '#DBEAFE'},
		credentials: {experience: '8+ Years', primaryMetric: '70+ launches'},
		highlights: [{text: 'React apps'}, {text: 'SEO basics'}, {text: 'Automation'}],
		isFeatured: false,
		createdAt: '2026-05-06T08:00:00.000Z',
	},
	{
		_id: 'yp-static-006',
		entityType: 'hybrid',
		entityName: 'Aarohi Interiors & Home Care',
		tagline: 'Compact renovations, civil repairs, and tasteful interior upgrades for family homes.',
		description: 'Home improvement team with transparent scope and site supervision.',
		categories: ['CONSTRUCTION_HOME'],
		isPhysical: true,
		location: 'Nashik',
		serviceArea: '',
		photos: {logo: {url: ''}},
		verification: {isVerified: true},
		rating: {average: 4.5, count: 31},
		primaryCta: 'call',
		priceRange: 'mid-range',
		entityContactDetails: {
			whatsApp: {dialingCode: '+91', number: '9876543207'},
			calling: {dialingCode: '+91', number: '9876543208'},
			sameNumberForCalling: false,
			websiteLink: '',
		},
		listedBy: {displayName: 'Sanjay Joglekar', nativePlace: 'Sangameshwar', imageUrl: 'SJ', imageUrlBg: '#ECFCCB'},
		credentials: {experience: '18+ Years', primaryMetric: '220+ homes'},
		highlights: [{text: 'Civil repair'}, {text: 'Interiors'}, {text: 'Site visits'}],
		isFeatured: false,
		createdAt: '2026-04-22T08:00:00.000Z',
	},
];

export const spotlightListing = mockListings[1];
export const featuredListings = mockListings.filter(item => item.isFeatured);
export const newestListings = [...mockListings].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).slice(0, 4);

export const communityNotes = [
	{icon: CheckCircle2, title: 'Known member context', text: 'Each listing carries a listed-by member snapshot, native place, and verification state.'},
	{icon: Sparkles, title: 'Premium discovery', text: 'Categories, ratings, contact preferences, and service mode are visible before opening a profile.'},
	{icon: Scale, title: 'Clear listing profile', text: 'Every card highlights what matters first: offering, trust, location, owner, and contact preference.'},
];

export const priceRangeLabels = {
	'budget-friendly': 'Budget-friendly',
	'mid-range': 'Mid-range',
	premium: 'Premium',
};

export const entityTypeLabels = {
	product: 'Products',
	service: 'Services',
	hybrid: 'Products & Services',
};

export const getCategory = key => categoryMeta[key] || categoryMeta.OTHER;
export const ratingLabel = rating => `${Number(rating?.average || 0).toFixed(1)} (${rating?.count || 0})`;
